/**
 * Helpers voor ophaal-reminder-state.
 */

import { supabase } from './supabase';

async function authHeader(): Promise<Record<string, string>> {
  const { data } = await supabase.auth.getSession();
  const token = data.session?.access_token;
  return token ? { Authorization: `Bearer ${token}` } : {};
}

/**
 * Count voor sidebar-badge. Telt WO's met
 * `In_Ophaal_Reminder_Sequence__c=true AND (count>=3 OR bounced)`.
 */
export async function fetchOphaalReminderActieVereistCount(): Promise<number> {
  const headers = await authHeader();
  const res = await fetch('/api/orders/reminder-actie-vereist-count', { headers });
  if (!res.ok) return 0;
  const data = (await res.json()) as { count?: number };
  return data.count ?? 0;
}

export interface ReactivateResult {
  ok: boolean;
  werkOrderId?: string;
  werkOrderNummer?: string;
  nieuweStatus?: string;
  message?: string;
  error?: string;
  code?: string;
}

/**
 * Heractiveer een geannuleerde WO terug in de ophaal-reminder-sequence.
 * Backend zet count=0, vlaggen reset, status terug naar 'Ophalen plannen'.
 */
export async function reactivateOphaalReminder(werkOrderId: string): Promise<ReactivateResult> {
  const headers = await authHeader();
  const res = await fetch('/api/orders/reactivate-ophaal-reminder', {
    method: 'POST',
    headers: { ...headers, 'Content-Type': 'application/json' },
    body: JSON.stringify({ werkOrderId }),
  });
  const data = (await res.json()) as ReactivateResult;
  return { ...data, ok: res.ok && data.ok !== false };
}
